export function fetch_retry(url: string, options: any, n: number): Promise<Response> {
    return fetch(url, options).catch(function (error) {
        if (n === 1) throw error;
        const retries_left = n - 1;
        console.log(`Call to "${url}" failed, retrying (${retries_left} left)`);
        return fetch_retry(url, options, retries_left);
    });
}
